import * as React from 'react'
import { Input, Button, Message, Content } from 'components'
import { withMutation, ChildMutateProps } from '@apollo/client/react/hoc'
import { compose } from 'recompose'
import { UPDATE_EMAIL } from 'request/apollo/queries/account'
import { useCurrentUser } from 'utils/context/UserContext'
import { useTranslation } from 'i18n'

type Props = ChildMutateProps<{
  sendMessage: Function
}>

const initialState = {
  email: '',
  password: '',
}

const Component: React.FC<Props> = function ({
  sendMessage,
  mutate: updateEmail,
}) {
  const { t } = useTranslation('accountEmail')
  const [inputs, setInputs] = React.useState(initialState)
  const [loading, setLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)

  const onSubmit = async () => {
    setLoading(true)
    updateEmail({ variables: inputs })
      .then(() => {
        setInputs(initialState)
        setLoading(false)
        sendMessage(t('index.sendSuccessMessage'))
      })
      .catch(error => {
        setLoading(false)
        if (error.details) {
          setErrorMessage(error.details.map(e => e.message))
          return
        }
        setErrorMessage(error.message)
      })
  }

  const { currentUser } = useCurrentUser()

  return (
    <Content.Base>
      <h1>{t('index.changeEmailAddress')}</h1>
      <div style={{ padding: '20px 0 20px 0' }}>
        <h3>{t('index.currentEmailAddress')}</h3>
        <span>{currentUser?.email}</span>
      </div>
      {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
      <Input.Default
        fullWidth
        title={t('index.newEmailAddress')}
        value={inputs.email}
        onChange={e => setInputs({ ...inputs, email: e.currentTarget.value })}
      />
      <Input.Default
        type="password"
        fullWidth
        title={t('index.password')}
        value={inputs.password}
        onChange={e =>
          setInputs({ ...inputs, password: e.currentTarget.value })
        }
      />
      <p style={{ padding: '30px 0 30px 0', whiteSpace: 'pre-line' }}>
        {t('index.plzCheckConfirmEmail')}
      </p>
      <Button.Default
        loading={loading}
        fullWidth
        color="primary"
        onClick={onSubmit}
      >
        {t('index.saveChanges')}
      </Button.Default>
    </Content.Base>
  )
}

const ComposedComponent = compose(
  Message.withMessage,
  withMutation(UPDATE_EMAIL)
)(Component)

export default ComposedComponent
